import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const History = (): React.JSX.Element => {
    return (
        <div data-testid="historyContent">
            <Container className="py-5">
                <Row>
                    <Col>
                        <p>
                            The league was created in 2004 as the Great Lakes
                            Youth Baseball League by a group of individuals who
                            were dissatisfied with the philosophy of what at the
                            time was the largest youth baseball league in SE
                            Wisconsin. Prior to the 2006 season the founders of
                            the league were no longer able to administer the
                            league, so they passed the league onto Shawn
                            Kramlich. That 2006 season the league had 2 age
                            levels and only 11 teams.
                        </p>
                        <p>
                            Since taking over the league in 2006, Shawn has
                            provided much of the impetus behind the explosive
                            growth of youth baseball in Wisconsin. The first
                            change he made was allowing 11 year olds to play
                            using real baseball rules (leading off and
                            stealing). Then 10 and 9 year olds were given the
                            same opportunity. For many years, we were the only
                            league in Wisconsin offering such opportunities.
                            What we take for granted today, 9-11 year olds
                            playing real baseball, was not an option until the
                            MAJOR YBL started offering it in 2006.
                        </p>
                        <p>
                            Still very modest in size in 2009, the league had
                            nearly tripled in size to 32 teams.In 2011, the
                            league had grown substantially to 78 teams. Also in
                            2011, we were the first league in Wisconsin to offer
                            a league for 8-year-olds.
                        </p>
                        <p>
                            As the league continued to innovate and set the
                            direction of youth baseball in Wisconsin, in 2012 it
                            surpassed 100 teams. Then just 2 years later, in
                            2014 we became the first and only league to date in
                            Wisconsin to surpass 200 teams and became the
                            largest youth baseball league in Wisconsin that
                            year. The innovation continued during this period as
                            the league added competition based breakdowns at
                            each age level and then added geographic breakdowns.
                        </p>
                        <p>
                            The addition of the competitive and geographic
                            breakdowns really accelerated the league's grow. In
                            just 3 years the league grew from 200 teams in 2014
                            to over 300 teams for the 2017 season.The
                            innovations have continued, with the introduction of
                            our 7-year-old select baseball in 2017 and for the
                            2019 season offering leagues for 15U-18U players.
                            The MAJOR YBL now offers the opportunity for
                            children to play baseball from age 7 to 18. No other
                            league in Wisconsin offers the same. As we look
                            towards the future, as the clear trendsetter in
                            youth baseball in Wisconsin, the future looks very
                            bright.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default History;
